import '../utils/responsiveHelper';
import '../utils/accordion';

const initDescriptionAccordion = () => {
  window.ResponsiveHelper.addRange({
    '..1023': {
      on: () => {
        jQuery('.single-product-details__content .tab-content').slideAccordion({
          opener: '.subtitle',
          slider: '.mobile-slide',
          animSpeed: 300,
        });
      },
      off: () => {
        jQuery('.single-product-details__content .tab-content').slideAccordion('destroy');
      },
    },
  });
};

export default initDescriptionAccordion;
